import WidgetBase from '../widget.base';
import { each } from 'App/lib/util';

export default class FAQ extends WidgetBase {
    static selector = '[data-js-accordion]';

    constructor(el) {
        super(el);

        this.$el = $(el);
        this.$headers = this.$el.find('[data-js-header]');

        each(this.$headers, (header) => {
            $(header).on('click', this.handleClick.bind(this));
        });

        setTimeout(() => {
            this.loaded();
        });
    }

    handleClick(e){
        const $target = $(e.currentTarget);

        if($target.hasClass('open')){
            $target.removeClass('open').next().slideUp();
        } else{
            $target.addClass('open').next().slideDown();
        }
    }
}
